import React from 'react'
import {Flex} from '/app/src/component'

class ButtonText extends React.Component {
    constructor(props){
        super(props)
        this._onClick = this._onClick.bind(this)
    }
    _onClick(e){
        e.stopPropagation();
        e.target.value = this.props.text
        if(this.props.onClick) this.props.onClick(e)
    }
    render() {
        let {title, text,active, fontSize, ...rest} = this.props
        return (
            <Flex
                shrink={0}
                borderRadius='60px'
                backgroundHover={active?'darkblue': 'mediumgrey'}
                hover={active?'white': 'black'}
                fontSize={fontSize?fontSize:'24px'}
                color={active?'white':'black'}
                backgroundColor={active?'darkblue':'darkwhite'}
                height='38px'
                padding='0px 10px'
                center
                cursor='pointer' onClick={this._onClick} {...rest}>
                {text}
            </Flex>
        );
    }
}

export default ButtonText



// WEBPACK FOOTER //
// ./src/component/TextButton.js